var _rect, _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.830566,
    y: 0.620453,
    width: 47.7591,
    height: 47.7591,
    rx: 23.8796,
    fill: "#E9E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2275 38.8126H25.1649L25.1035 38.8253C24.9725 38.8526 24.8393 38.868 24.7056 38.8711C24.0905 38.8661 23.5018 38.6204 23.0657 38.1864C22.7762 37.8984 22.5693 37.5427 22.4605 37.1562H26.9447C26.9187 37.2576 26.8859 37.3574 26.8464 37.4549C26.6954 37.7987 26.4652 38.1021 26.1747 38.3402C25.8982 38.5668 25.5744 38.7281 25.2276 38.8126H25.2275ZM16.1901 31.2307L16.5261 31.0627V30.687V22.6277V22.6163L16.5256 22.605C16.4525 20.6469 16.8939 18.704 17.8057 16.9698C18.2375 16.2086 18.8254 15.5473 19.5307 15.0291C20.2384 14.5091 21.0483 14.1451 21.9069 13.9611L22.3874 13.8581V13.3667V11.9307C22.3874 11.2953 22.9025 10.7801 23.538 10.7801H25.8825C26.5179 10.7801 27.0331 11.2953 27.0331 11.9307V13.3667V13.8469L27.5001 13.9581C29.2392 14.3721 30.569 15.3259 31.4751 16.7573C32.3892 18.2013 32.8944 20.1688 32.8944 22.6277V30.687V31.0627L33.2304 31.2307L35.1891 32.21C35.5789 32.4049 35.8251 32.8033 35.8251 33.2391V33.3246C35.8251 33.96 35.31 34.4752 34.6745 34.4752H14.746C14.1105 34.4752 13.5954 33.96 13.5954 33.3246V33.2391C13.5954 32.8033 13.8416 32.4049 14.2314 32.21L16.1901 31.2307Z",
    stroke: "black",
    strokeWidth: 1.21569
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8306,
    cy: 15.5,
    r: 4,
    fill: "#F23985"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f57664ec958f596a25bb8cc568607d99.svg";
export { ForwardRef as ReactComponent };